
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app.routing';
import { NoAuthGuard } from '../forgotpwd/no-auth-guard.service';
import { ResetpassComponent } from './resetpass.component';
//import {ConformComponent} from '../conform/conform.component'
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
  imports: [
    AppRoutingModule,
    FormsModule,
    MatDialogModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    ResetpassComponent,
    // ConformComponent
  ],

  providers: [
    NoAuthGuard
  ],
  entryComponents: [
    //  ConformComponent
  ]
})
export class ResetpassModule { }